import * as React from 'react';
import { Component, inject, observer, deps } from '../../lib/component';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import youtube from '../../static/youtube.svg';

export interface UserLoginLinkProps extends InjectedIntlProps {
  iconClass?: string;
  labelClass?: string;
  firstPaint: boolean;
  noLogo?: boolean;
  redirectTo?: string;
}

@inject(deps) @injectIntl @observer
export class UserLoginLink extends Component<UserLoginLinkProps> {
  render() {
    if (this.props.model.auth.user && !this.props.firstPaint) return null;

    const title = this.props.intl.formatMessage({id: 'user.login'});
    const { redirectTo } = this.props;
    const href = redirectTo
      ? this.props.model.auth.youtubeRedirect(redirectTo)
      : this.props.model.auth.youtubeLoginURL;

    return (
      <a target="_self" href={href} title={title} onClick={this.handleClick}>
        {!this.props.noLogo && (<img className={this.props.iconClass} src={youtube} />)}
        <span className={this.props.labelClass}> {title}</span>
      </a>
    )
  }

  handleClick = (event: React.MouseEvent<any>) => {
    event.preventDefault();
    this.props.controller.onboarding.openSignUpModal(this.props.redirectTo);
  }
}
